import { useContext } from 'react';
import { OrganisationFilterContext } from './organisationContext';
import type { OrganisationFilterContextValue } from './organisationTypes';

export const useOrganisationFilter = (): OrganisationFilterContextValue => {
  const ctx = useContext(OrganisationFilterContext);
  if (!ctx) {
    throw new Error('useOrganisationFilter must be used within OrganisationFilterProvider');
  }
  return ctx;
};
